import { render, staticRenderFns } from "./ArchivedInfoCardListTable.vue?vue&type=template&id=040dbad2&scoped=true&"
import script from "./ArchivedInfoCardListTable.vue?vue&type=script&lang=js&"
export * from "./ArchivedInfoCardListTable.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedInfoCardListTable.vue?vue&type=style&index=0&id=040dbad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040dbad2",
  null
  
)

export default component.exports